module.exports = __webpack_public_path__ + "static/28_PLATOS-COL-BANDEJA-PAISAD.dc4f06d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/foods/28_PLATOS-COL-BANDEJA-PAISAD.png
// module id = 675
// module chunks = 35783957827783